export default __webpack_public_path__ + "static/media/it930-a033-3.8853c3f4.jpg";